<template>
  <div class="rating">
    <HundredHeader />
    <HundredBody />
  </div>
</template>

<script>
import HundredHeader from './components/Header';
import HundredBody from './components/Body';

export default {
  components: {
    HundredHeader,
    HundredBody
  },
  data: () => ({
    isShowModal: false,
    filter: {
      userName: '',
      course: '',
      dateStart: '',
      dateEnd: '',
      sort: {
        channelId: null,
        // 0 - DESC; 1 - ASC
        sortType: null
      }
    },
    navTitles: [
      {
        title: 'Имя',
        id: 1,
        width: '2fr'
      },
      {
        title: 'Ниша',
        id: 2,
        width: '1fr'
      },
      {
        title: 'Выручка',
        id: 3,
        width: '1fr',

        channelId: 0,
        sortType: 0
      },
      {
        title: 'Прибыль',
        id: 4,
        width: '1fr',

        channelId: 1,
        sortType: 0
      }
    ]
  })
};
</script>
